import { render, staticRenderFns } from "./tooltip-icon.vue?vue&type=template&id=3ede115a&scoped=true&lang=pug&"
import script from "./tooltip-icon.vue?vue&type=script&lang=js&"
export * from "./tooltip-icon.vue?vue&type=script&lang=js&"
import style0 from "./tooltip-icon.vue?vue&type=style&index=0&id=3ede115a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ede115a",
  null
  
)

export default component.exports